import { Button, ButtonMode } from '@creditsights/styleguide-web';
import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import styles from '../Modal.module.scss';
import { FieldValues } from '../types';

const Step21 = (): React.ReactElement => {
  const { register, setValue, watch } = useFormContext<FieldValues>();
  const transactionType = watch('transactionType');

  return (
    <>
      <div className={styles.modalHeader}>Select a deadline & transaction type</div>
      <div className={styles.modalSubHeader}>
        To best process your loan research request, select a deadline (if any) and transaction type.
      </div>
      <div className={styles.modalFormLine}>
        <div className={styles.modalFormLabel}>
          Deadline: <span>(if any)</span>
        </div>
        <input
          className={classNames(styles.modalFormInput, styles.modalFormInputDate)}
          type="date"
          placeholder="Select a date"
          onClick={(e) => e.currentTarget.showPicker()}
          {...register('date')}
        />
      </div>
      <div className={styles.modalFormLine}>
        <div className={styles.modalFormLabel}>Transaction type:</div>
        <Button
          className={styles.modalFormButton}
          mode={transactionType === 'syndicated' ? ButtonMode.PRIMARY : ButtonMode.SECONDARY}
          onClick={() => setValue('transactionType', 'syndicated')}
        >
          Syndicated
        </Button>
        <Button
          className={styles.modalFormButton}
          mode={transactionType === 'private' ? ButtonMode.PRIMARY : ButtonMode.SECONDARY}
          onClick={() => setValue('transactionType', 'private')}
        >
          Non-Syndicated / Private Credit
        </Button>
        <Button
          className={styles.modalFormButton}
          mode={transactionType === 'toBeSyndicated' ? ButtonMode.PRIMARY : ButtonMode.SECONDARY}
          onClick={() => setValue('transactionType', 'toBeSyndicated')}
        >
          Will be Syndicated
        </Button>
      </div>
    </>
  );
};

export default Step21;
